import { CopyButton, StyledTooltip } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCopyToClipboard } from './use-copy-to-clipboard.hook';
import { useIntl } from 'react-intl';

interface Props {
  value: string;
}

export const CopyIdButton = ({ value }: Props): JSX.Element | null => {
  const { formatMessage } = useIntl();
  const [isCopied, copy] = useCopyToClipboard(value);

  if (!navigator.clipboard) {
    return null;
  }

  return (
    <StyledTooltip
      text={isCopied && formatMessage({ id: 'copied' })}
      placement="top"
      alignment="center"
      showArrow={false}
    >
      <CopyButton type="button" onClick={copy} aria-label={formatMessage({ id: 'copy' })} data-testid="copy-id-button">
        <FontAwesomeIcon icon={['far', 'copy']} />
      </CopyButton>
    </StyledTooltip>
  );
};
